import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  BudgetBudgetHistoryMatchParams,
  budgetHistoryRouteProps,
} from 'src/navigation/routeProps'
import { GetBudgetRevisionsPagination } from 'src/redux/actions/data/budgetRevisions.actions'
import { RootState } from 'src/redux/createRootReducer'
import { selectBudgetRevisionListModelsFromState } from 'src/redux/selectors/data/budgetRevisions.selectors'
import { selectCreditCardListModelsFromState } from 'src/redux/selectors/data/creditCards.selectors'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectCreditCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<BudgetBudgetHistoryMatchParams>(
      backgroundLocation.pathname,
      budgetHistoryRouteProps,
    ) as match<BudgetBudgetHistoryMatchParams>
    return mtch.params.id
  },
)

export const selectCreditCard = createSelector(
  [selectCreditCardListModelsFromState, selectCreditCardIdFromRoute],
  (creditCards, creditCardId) => {
    return creditCards[creditCardId] !== undefined
      ? creditCards[creditCardId]
      : undefined
  },
)

const selectBudgetRevisionIdsFromState = (state: RootState): string[] =>
  state.app.budget.budgetHistory.revisionIds

export const selectBudgetRevisions = createSelector(
  [selectBudgetRevisionIdsFromState, selectBudgetRevisionListModelsFromState],
  (revisionIds, revisions) => revisionIds.map((id) => revisions[id]),
)

export const selectFullyLoadedRevisionsFromState = (
  state: RootState,
): boolean => state.app.budget.budgetHistory.fullyLoadedRevisions

export const selectRevisionsLoadingFromState = (state: RootState): boolean =>
  state.app.budget.budgetHistory.revisionsLoading

export const selectRevisionsPaginationFromState = (
  state: RootState,
): GetBudgetRevisionsPagination =>
  state.app.budget.budgetHistory.revisionsPagination
